import { render, staticRenderFns } from "./BrandUsageDetails.vue?vue&type=template&id=f33f6b38&scoped=true"
import script from "./BrandUsageDetails.vue?vue&type=script&lang=js"
export * from "./BrandUsageDetails.vue?vue&type=script&lang=js"
import style0 from "./BrandUsageDetails.vue?vue&type=style&index=0&id=f33f6b38&prod&scoped=true&lang=scss"
import style1 from "./BrandUsageDetails.vue?vue&type=style&index=1&id=f33f6b38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33f6b38",
  null
  
)

export default component.exports